@custom-media --mobile (max-width: 768px);
@custom-media --tablet (max-width: 1024px);

.variableContainer {
  padding-bottom: 2em;
  border-bottom: 1px solid var(--darkSilver);
  margin-bottom: 2em;
}

.variableHeader {
  text-transform: uppercase;
}

.infoContainer {
  @media (--tablet) {
    display: flex;
    flex-direction: column;
  }
}

.descriptionContainer {
  margin-right: 1.5em;

  @media (--mobile) {
    margin-right: 0;
    margin-bottom: 1em;
  }
}

.descriptionContainer::after {
  content: " ";
  clear: both;
  display: block;
}

.chartContainer {
  width: 350px;
  margin-left: 10px;
  float: right;
}
